import { useMemo } from 'react';
import { Provider } from 'react-redux';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StyledEngineProvider } from '@mui/material/styles';
import routes from 'app/configs/routesConfig';
import store from './store';
import AppContext from './AppContext';
import { de, pl, enUS } from 'date-fns/locale';

const browserLocale = navigator.language || 'en-US';

const localeMap = {
  'en-US': enUS,
  'de-DE': de,
  'pl-PL': pl,
  // add more?
};

const withAppProviders = (Component) => (props) => {
  const WrapperComponent = () => {
    const providerValue = useMemo(() => {
      return { routes };
    }, [routes]);

    return (
      <AppContext.Provider value={providerValue}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={localeMap[browserLocale]}>
          <Provider store={store}>
            <StyledEngineProvider injectFirst>
              <Component {...props} />
            </StyledEngineProvider>
          </Provider>
        </LocalizationProvider>
      </AppContext.Provider>
    );
  };

  return WrapperComponent;
};

export default withAppProviders;
